export const calculators = [
	{
		name: 'Compound Interest Calculator',
		url: 'compound-interest-calculator',
		description:
			'Calculate the compound interest of your investment or for how long can your invested money last with this calculator. Additionally, logged in users can save their calculations.',
	},
	{
		name: 'Annualized Return Calculator',
		url: 'annualized-return-calculator',
		description:
			'Calculate the annualized return (CAGR) and or the the total percent return of your investment with this calculator. Additionally, logged in users can save their calculations.',
	},
	{
		name: 'Present Value Calculator',
		url: 'present-value-calculator',
		description:
			'Calculate the present value of your future investment with a specified discount rate with this calculator. Additionally, logged in users can save their calculations.',
	},
	{
		name: 'Investment Time Calculator',
		url: 'investment-time-calculator',
		description:
			'Calculate the amount of time needed to grow an investment to a certain future value given an annual interest rate. Additionally, logged in users can save their calculations.',
	},
	{
		name: 'Break Even Point Calculator',
		url: 'break-even-point-calculator',
		description:
			'Calculate the point at which total cost and total revenue are equal, meaning there is no loss or gain for your business. Additionally, logged in users can save their calculations.',
	},
	{
		name: 'Markup Calculator',
		url: 'markup-calculator',
		description:
			'Calculate the difference between the cost and the selling price of your product. Additionally, logged in users can save their calculations.',
	},
];
